export const { incidentHasArrestee, incidentHasKnownOffender } = require('./incIncidentHelper');
